import { Pipe, PipeTransform } from '@angular/core';
import { UserRoles } from '../models/roles.model';

@Pipe({
  name: 'userRoleFilter'
})
export class UserRoleFilterPipe implements PipeTransform {

  transform(items: UserRoles[], args?: any): any {
    if (args.hasOwnProperty('fkUserRole') && typeof items !== 'undefined') {

      let filteredItems = items.filter(item => item.idUserRole == args.fkUserRole);

      if (filteredItems.length > 0) {
        return filteredItems[0].userRoleName;

      } else {
        return "Sin resultado";
      }
    }
    return "Sin resultado";
  }

}
